import './About.css';

const PrivacyPolicy = () => {
  return (
    <div className="about-page">
      <div className="page-header">
        <div className="container">
          <h1>Privacy Policy</h1>
          <p>Our commitment to your privacy</p>
        </div>
      </div>
      <section className="section">
        <div className="container">
          <div className="about-content">
            <p>This page is under construction. Please check back later for our privacy policy.</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
